/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'
import BigNumber from 'bignumber.js'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { QUICK_BUY_AMOUNT_NATIVE } from '@root/entities/trade-settings/model/trade-settings'
import { Error } from '@root/shared'
import { NumericFormat } from '@root/shared/core/format'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { tradeSettingsModel } from '..'

import { updateQuickAmountSettingsRequestAction } from './trade-settings-requests'

import type { TradeSettingsQuick } from '@root/entities/trade-settings/model'

export const updateQuickBuyAmountAction = action(
  async (
    ctx,
    {
      amount,
      section,
    }: { amount: BigNumber; section: TradeSettingsQuick.QuickSwapSection },
  ) => {
    const network = ctx.get(selectedNetworkAtom)
    const quickBuyAmount = QUICK_BUY_AMOUNT_NATIVE[network]
    const isAboveAllowed = amount.gt(quickBuyAmount.max)

    if (isAboveAllowed) {
      showSnackbarAction(ctx, {
        text: i18next.t('trade-settings.quick-buy-amount-updated-message-max', {
          amount: NumericFormat.formatPreset(quickBuyAmount.max, 'full'),
        }),
        intent: 'error',
      })
      return Result.fail(Error.UnknownError.fromUnknown('invalid input'))
    }

    const result = await ctx.schedule(() =>
      updateQuickAmountSettingsRequestAction(ctx, {
        network,
        section,
        side: 'buy',
        value: amount.toNumber(),
      }),
    )

    if (Result.isSuccess(result)) {
      const amount = result.success.quickAmounts[section].buy
      BigNumber(0)

      const network = ctx.get(selectedNetworkAtom)
      tradeSettingsModel.setTradeSettingsPresets(ctx, {
        network,
        presets: result.success,
      })

      showSnackbarAction(ctx, {
        text: i18next.t('trade-settings.quick-buy-amount-updated-message', {
          amount: NumericFormat.formatPreset(amount, 'full'),
        }),
        intent: 'success',
      })
    } else {
      showSnackbarAction(ctx, {
        text: i18next.t(
          'trade-settings.quick-buy-amount-updated-error-message',
        ),
        intent: 'error',
      })
    }
  },
)
